// src/pages/shared.js
// Styled bits shared across Hub pages (Dashboard/PageView/Admin) so rendered
// Markdown looks identical wherever it appears (live page vs. admin preview).
import styled from 'styled-components';

export const Prose = styled.div`
  color: #1e293b;
  font-size: 15px;
  line-height: 1.7;

  h1, h2, h3, h4 {
    color: #1e293b;
    font-weight: 700;
    margin: 28px 0 12px 0;
  }

  h1 { font-size: 22px; }
  h2 { font-size: 19px; }
  h3 { font-size: 16px; }

  p {
    margin: 0 0 16px 0;
  }

  a {
    color: #0e8c6a;
    text-decoration: underline;
  }

  ul, ol {
    margin: 0 0 16px 0;
    padding-left: 24px;
  }

  li {
    margin-bottom: 6px;
  }

  code {
    background: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 13px;
  }

  pre {
    background: #0f172a;
    color: #e2e8f0;
    padding: 16px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 0 0 16px 0;
  }

  pre code {
    background: none;
    padding: 0;
  }

  blockquote {
    border-left: 3px solid #0e8c6a;
    margin: 0 0 16px 0;
    padding: 4px 16px;
    color: #64748b;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 0 0 16px 0;
    font-size: 14px;
  }

  th, td {
    border: 1px solid #e2e8f0;
    padding: 8px 12px;
    text-align: left;
  }

  th {
    background: #f8fafc;
    font-weight: 600;
  }

  hr {
    border: none;
    border-top: 1px solid #e2e8f0;
    margin: 24px 0;
  }

  img {
    max-width: 100%;
  }
`;
